import { CompanyListParams } from '@/features/company/types/company-list.types';
import { IFilter } from '@/shared';

export const companyQueryKeys = {
  featuredList: ['featured-companies'] as const,
  goldenList: ['golden-companies'] as const,
  company: ['company'] as const,
  list: (params: CompanyListParams) =>
    [...companyQueryKeys.company, 'list', params] as const,
  detail: (alias: string) =>
    [...companyQueryKeys.company, 'detail', alias] as const,
  followedCompanies: {
    all: ['followed-companies'] as const,
    list: (filters: IFilter = {}) =>
      [...companyQueryKeys.followedCompanies.all, 'list', filters] as const,
  },
  followedCompanyIds: ['followed-company-ids'] as const,
  awards: (companyId: number) =>
    [...companyQueryKeys.company, 'awards', companyId] as const,
  followerCount: (companyId: number) =>
    [...companyQueryKeys.company, 'follower-count', companyId] as const,
  groups: (companyId: number) =>
    [...companyQueryKeys.company, 'groups', companyId] as const,
  contents: (companyId: number) =>
    [...companyQueryKeys.company, 'contents', companyId] as const,
} as const;
